// Set the name of the hidden property and the change event for visibility
let hidden, visibilityChange;
if (typeof document.hidden !== 'undefined') { // Opera 12.10 and Firefox 18 and later support
  hidden = 'hidden';
  visibilityChange = 'visibilitychange';
} else if (typeof document.msHidden !== 'undefined') {
  hidden = 'msHidden';
  visibilityChange = 'msvisibilitychange';
} else if (typeof document.webkitHidden !== 'undefined') {
  hidden = 'webkitHidden';
  visibilityChange = 'webkitvisibilitychange';
}

const subscribers = [];

export function subscribeToVisibilityChange (callback) {
  subscribers.push(callback);
}
export function unsubscribeFromVisibilityChange (callback) {
  subscribers.filter(subscriber => subscriber !== callback);
}

const handleVisibilityChange = function () {
  // When the page opens from background do callback
  if (!document[hidden]) {
    subscribers.forEach(subscriberAction => subscriberAction());
  }
};

export function addVisibilityListener () {
  // Check if the browser support addEventListener and the Page Visibility API
  if (typeof document.addEventListener !== 'undefined' && hidden !== undefined) {
    document.addEventListener(visibilityChange, handleVisibilityChange, false);
  }
}

export function removeVisibilityListener () {
  // Check if the browser support addEventListener and the Page Visibility API
  if (typeof document.removeEventListener !== 'undefined' && hidden !== undefined) {
    document.removeEventListener(visibilityChange, handleVisibilityChange, false);
  }
}



// WEBPACK FOOTER //
// ./src/helpers/handleDocumentVisibility.js